import { render, staticRenderFns } from "./reviews-counter.vue?vue&type=template&id=bca06fb6"
import script from "./reviews-counter.vue?vue&type=script&lang=ts"
export * from "./reviews-counter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports